<!-- https://api.iconify.design/fe:disabled.svg -->
<svg {...$$props} viewBox="0 0 24 24" fill="currentColor">
  <path
    d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10Zm-4.906-3.68L18.32 7.094A8 8 0 0 1 7.094 18.32ZM5.68 16.906A8 8 0 0 1 16.906 5.68L5.68 16.906Z"
  />
</svg>
